import { Action, ActionType } from './attestationView.actions';
import { Attestation } from './attestationView.types';

export const reducer = (state: Attestation[], action: Action) => {
  switch (action.type) {
    case ActionType.UPDATE_OPTION: {
      const attestations = [...state];
      const attestation = attestations[action.payload.attestIndex];
      if (attestation) {
        attestations[action.payload.attestIndex] = {
          ...attestation,
          option: action.payload.option
        };

        return attestations;
      }

      return state;
    }
    case ActionType.UPDATE_STEP: {
      const attestations = [...state];
      const attestation = attestations[action.payload.attestIndex];
      if (attestation) {
        attestations[action.payload.attestIndex] = {
          ...attestation,
          step: action.payload.step
        };

        return attestations;
      }

      return state;
    }
    case ActionType.UPDATE_TEXT: {
      const attestations = [...state];
      const attestation = attestations[action.payload.attestIndex];
      if (attestation) {
        attestations[action.payload.attestIndex] = {
          ...attestation,
          text: action.payload.text
        };

        return attestations;
      }

      return state;
    }

    default:
      return state;
  }
};
